const state = () => ({
    user: null,
    bodyTemperature: null,
    medicalCourse: null,
    transQuestions: null,
    transProfile: null,
    transAnswers: null,
})

const mutations = {
    setUser (state, value) {
        state.user = value
    },

    setBodyTemperature (state, value) {
        state.bodyTemperature = value
    },

    setMedicalCourse (state, value) {
        state.medicalCourse = value
    },

    setTransQuestions (state, value) {
        state.transQuestions = value
    },

    setTransProfile (state, value) {
        state.transProfile = value
    },

    setTransAnswers (state, value) {
        state.transAnswers = value
    },

    clearStates (state) {
        state.user = null
        state.bodyTemperature = null
        state.medicalCourse = null
        state.transQuestions = null
        state.transProfile = null
        state.transAnswers = null
    },
}

const getters = {}
const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
